import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

interface Props extends CommandsListProps {
    role: "preparer" | "reviewer" | "manager" | "client";
    optionsKey:
        | "occurrenceBulkPreparerOptions"
        | "occurrenceBulkReviewerOptions"
        | "occurrenceBulkManagerOptions"
        | "occurrenceBulkClientOptions";
}

export const OccurrenceBulkMemberCommandsList: FC<Props> = ({
    options = {},
    role,
    optionsKey,
}) => {
    const { selectedOccurrenceCount = 0 } = options;
    const memberOptions = options[optionsKey] ?? [];

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set ${role} for ${selectedOccurrenceCount} ${pluralize("occurrence", selectedOccurrenceCount)}`}
            options={memberOptions}
        />
    );
};
